<template>
  <div>
    <WxLoginNei></WxLoginNei>
  </div>
</template>

<script>
import WxLoginNei from './base/WxLoginNei';

export default {
  name: 'wxLogin',
  components: {
    WxLoginNei,
  },
};
</script>

<style scoped lang="less">
/deep/#app .el-container {
  display: none;
}
</style>
